import React, { useCallback } from 'react'

export const useErrorState = (): {
  errorMessage: string
  setMessage: (message: string) => void
  fetchErrorMessage: () => string
} => {
  const [errorMessage, setErrorMessage] = React.useState<string>('')
  const setMessage = useCallback((message: string) => {
    console.warn('deprecated set error message being used, API errors will be automatically handled, use setAlertMessage to show alerts')
    setErrorMessage(message)
  }, [])
  const fetchErrorMessage = () => {
    return errorMessage
  }
  return {
    errorMessage,
    setMessage,
    fetchErrorMessage,
  }
}
